import React, { useRef } from "react";
import InputBoxes from "../common/InputBoxes";
import { checkChildrenAndSetFocus, NO_OF_BUSINESS_NAME_COLUMN } from "../common/interactiveCommon";
const KS10BusinessName = (props) => {
  const { businessName, setBusinessNameData } = props;
  const businessNameDivRef = useRef(null);
  const onTextChange = (e) => {
    const { name, value } = e.target;
    const index = name.replace("businessName", "");
    checkChildrenAndSetFocus(businessNameDivRef.current.children, index);
    setBusinessNameData({ name, value });
  };
  return (
    <div className="row">
      <div className="mb-3 section-number-box col-sm-12 col-md-12 col-lg-12">
        <div className="mb-3 number">9.</div>
        <div className="details">
          <div className="form-group form-inline ">
            <div className="section-label">
              <label className="">Employer's business name</label>
            </div>
            <div className="section-form-group">
              <div className="section-form-group-inline" ref={businessNameDivRef}>
                <InputBoxes keyName={"businessName"} name={businessName} count={NO_OF_BUSINESS_NAME_COLUMN} onTextChange={onTextChange} set20PXWidth={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS10BusinessName;
